import React from 'react'
import {CreateAgreementStep4PropDataType} from '../agreementDataType'

const CreateAgreementStep4 = ({formik, province}: CreateAgreementStep4PropDataType) => {
  return (
    <div className='card mb-5 mb-xl-10 w-100'>
      <div className='card-header border-0 d-flex justify-content-between align-items-center'>
        {/* Begin: heading */}
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Other Details</h3>
        </div>
        {/* End: heading */}
      </div>
      <div className='card-body border-top px-9 pt-9 pb-2'>
        {/*Begin::Form Group Select signing pages */}
        <div className='row mb-2'>
          <label className='col-lg-4 col-form-label fw-bold fs-6'>
            <span className='required'>Select signing pages</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Choose signing pages'
            ></i>
          </label>
          <div className='col-lg-8 fv-row'>
            <select
              className='form-select form-select-solid'
              {...formik.getFieldProps('sign_on_page')}
              name='sign_on_page'
              placeholder='Select signing pages'
            >
              <option className='bg-color-gray' value=''>
                Select signing pages
              </option>
              {formik.values.agreement_type === 'create' ? (
                <option value='custom'>Custom</option>
              ) : (
                <>
                  {' '}
                  <option value='first'>First</option>
                  <option value='last'>Last</option>
                  <option value='all'>All</option>
                </>
              )}
            </select>
            <div className='h-20px'>
              {formik.touched.sign_on_page && formik.errors.sign_on_page && (
                <div className='fv-help-block color-red'>{formik.errors.sign_on_page}</div>
              )}
            </div>
          </div>
        </div>
        {/*End::Form Group Select signing pages */}
        {/*Begin::Form Group Is eStamp required */}
        <div className='row'>
          <label className='col-lg-4 col-form-label fw-bold fs-6'>
            <span className='required'>Is eStamp required</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Choose whether eStamp is required or not'
            ></i>
          </label>
          <div className='col-lg-4'>
            <input
              type='radio'
              {...formik.getFieldProps('is_estamp')}
              className='btn-check'
              name='is_estamp'
              value='true'
              id='is_estamp_required'
              checked={formik.values.is_estamp === 'true'}
              onChange={(e) => {
                formik.setFieldValue('is_estamp', e.target.value)
              }}
            />
            <label
              className='btn btn-outline btn-outline-dashed btn-outline-default p-2 d-flex align-items-center mb-2'
              htmlFor='is_estamp_required'
            >
              <i
                className={`bi bi-check-square-fill fs-1 me-5 ${
                  formik.values.is_estamp === 'true' && 'text-primary'
                }`}
              ></i>
              <span className='d-block fw-bold text-start'>
                <span className='text-dark fw-bolder d-block fs-4'>Yes</span>
                <span className='text-gray-400 fw-bold fs-6'>Provide eStamp</span>
              </span>
            </label>
          </div>
          <div className='col-lg-4'>
            <input
              type='radio'
              className='btn-check'
              {...formik.getFieldProps('is_estamp')}
              name='is_estamp'
              value='false'
              id='is_estamp_not_required'
              checked={formik.values.is_estamp === 'false'}
              onChange={(e) => {
                formik.setFieldValue('is_estamp', e.target.value)
                formik.setFieldValue('estamp_amount', '')
                formik.setFieldValue('estamp_state', '')
              }}
            />
            <label
              className='btn btn-outline btn-outline-dashed btn-outline-default p-2 d-flex align-items-center'
              htmlFor='is_estamp_not_required'
            >
              <i
                className={`bi bi-x-square-fill fs-1 me-5 ${
                  formik.values.is_estamp === 'false' && 'text-primary'
                }`}
              ></i>
              <span className='d-block fw-bold text-start'>
                <span className='text-dark fw-bolder d-block fs-4'>No</span>
                <span className='text-gray-400 fw-bold fs-6'>Don't need eStamp</span>
              </span>
            </label>
          </div>
          <div className='col-lg-4'></div>
          <div className='col-lg-8'>
            <div className='h-20px'>
              {formik.touched.is_estamp && formik.errors.is_estamp && (
                <div className='fv-help-block color-red'>{formik.errors.is_estamp}</div>
              )}
            </div>
          </div>
          {formik.values.is_estamp === 'true' && (
            <>
            {/* Begin: eStamp amount field */}
              <div className='row mb-2'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>eStamp amount</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Choose eStamp amount'
                  ></i>
                </label>
                <div className='col-lg-8'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    name='estamp_amount'
                    placeholder='Enter eStamp amount'
                    {...formik.getFieldProps('estamp_amount')}
                  />
                  <div className='h-20px'>
                    {formik.touched.estamp_amount && formik.errors.estamp_amount && (
                      <div className='fv-help-block color-red'>{formik.errors.estamp_amount}</div>
                    )}
                  </div>
                </div>
              </div>
              {/* End: eStamp amount field */}
              {/* Begin: Province/State */}
              <div className='row mb-2'>
                {/*Begin::Form Group Select Province/State */}
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Select Province/State</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Choose province/state'
                  ></i>
                </label>
                <div className='col-lg-8 fv-row'>
                  <select
                    className='form-select form-select-solid'
                    {...formik.getFieldProps('estamp_state')}
                    name='estamp_state'
                    placeholder='Select province/state'
                  >
                    <option className='bg-color-gray' value=''>
                      Select province/state
                    </option>
                    {province &&
                      province.map((item, index: number) => {
                        return (
                          <option className='bg-color-gray' value={item.province_id}>
                            {item.province_name}
                          </option>
                        )
                      })}
                  </select>
                  <div className='h-20px'>
                    {formik.touched.estamp_state && formik.errors.estamp_state && (
                      <div className='fv-help-block color-red'>{formik.errors.estamp_state}</div>
                    )}
                  </div>
                </div>
                {/*End::Form Group Select Province/State */}
              </div>
              {/* End: Province/State */}
            </>
          )}
        </div>
        {/*Begin::Form Group Is eStamp required */}
      </div>
    </div>
  )
}

export default CreateAgreementStep4
